import React, { FormEvent, useContext, useState } from "react";
import { Button, ButtonGroup, Container, FormControl, FormErrorMessage, Input, useToast } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload as leftIcon } from "@fortawesome/free-solid-svg-icons";
import ContentContext from "../../../common/context/ContentContext";
import InputDialog from "../../../common/components/InputDialog";
import { useLazyMultipartRequest } from "../../../common/hooks/useLazyRequest";
import { ContentAttachment } from "../../../common/types";

const UploadFileForm = ({ contentId, setShowDialogue, onSuccess }: { contentId: string, onSuccess: (a: ContentAttachment) => void, setShowDialogue: React.Dispatch<React.SetStateAction<boolean>> }) => {
    const [
        {
            isLoading,
            hasError,
        },
        upload
    ] = useLazyMultipartRequest(`/content/${contentId}/attachment`, {
        onSuccess: (data: { attachment: ContentAttachment }) => {
            setShowDialogue(false);
            onSuccess(data.attachment as ContentAttachment);
        }
    });

    const onSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const data = new FormData(e.currentTarget);
        upload(data);
    }

    return (
        <Container maxW={"100%"}>
            <form onSubmit={onSubmit}>
                <FormControl isRequired>
                    <Input type="file" name="attachment" required />
                </FormControl>
                {!isLoading && hasError && <FormErrorMessage>No se ha podido cargar el archivo. Por favor intenta nuevamente</FormErrorMessage>}
                <FormControl mt="10px" display="flex" justifyContent="end">
                    <ButtonGroup spacing={4}>
                        <Button onClick={() => setShowDialogue(false)} disabled={isLoading}>Cancelar</Button>
                        <Button
                            colorScheme="green"
                            type="submit"
                            disabled={isLoading}
                        >
                            Subir
                        </Button>
                    </ButtonGroup>
                </FormControl>
            </form>
        </Container>
    );
}

const UploadFile = ({ onAttachmentUploaded }: { onAttachmentUploaded: (a: ContentAttachment) => void }) => {
    const content = useContext(ContentContext);
    const [showDialogue, setShowDialogue] = useState(false);
    const toast = useToast();

    const successToast = () =>
        toast({
            description: "Archivo guardado.",
            status: "success",
            variant: "subtle",
            duration: 5000,
            isClosable: true,
            position: "top-right",
            size: "small",
        });

    return (
        <>
            {content && (
                <>
                    {showDialogue &&
                        <InputDialog
                            isOpen={showDialogue}
                            onClose={() => setShowDialogue(false)}
                            header=<b>Subir Archivo</b>
                            body={<UploadFileForm contentId={content._id} setShowDialogue={setShowDialogue} onSuccess={
                                (a: ContentAttachment) => {
                                    onAttachmentUploaded(a);
                                    successToast();
                                }} />}
                        />}
                    <Button
                        colorScheme="telegram"
                        variant="outline"
                        leftIcon={<FontAwesomeIcon icon={leftIcon} />}
                        type="submit"
                        onClick={() => { setShowDialogue(true); }}
                    >
                        Subir Archivo
                    </Button>
                </>
            )}
        </>
    );
};

export default UploadFile;
